import React from 'react'
import '../assets/styles/Listfilm.css'
import { Link } from 'react-router-dom'

import  memory  from '../assets/images/Memory.PNG'
import  zeria  from '../assets/images/Zeria.PNG'
import  watcher  from '../assets/images/Watcher.PNG'
import  nocebo  from '../assets/images/Nocebo.PNG'
import  piaffe  from '../assets/images/Piaffe.PNG'
import  pieta  from '../assets/images/Pieta.PNG'
import  blood  from '../assets/images/Blood.PNG'
import  laTour  from '../assets/images/La tour.PNG'
import  laMontagne  from '../assets/images/La montagne.PNG'

function ListFilm() {
  return (
    <div className="listfilmContainer">
        <div className="listfilmTitle">
            <h1>Films en compétition</h1>
        </div>
        <div className="listfilm">
          <div id="memory">
            <Link to='/memory'><img src={memory} alt="affiche du film"/></Link>
          </div>
            <Link to="/zeria"><img src={zeria} alt="affiche du film"/></Link>
            <Link to="/watcher"><img src={watcher} alt="affiche du film"/></Link>
            <Link to="/nocebo"><img src={nocebo} alt="affiche du film"/></Link>
            <Link to="/piaffe"><img src={piaffe} alt="affiche du film"/></Link>
            <Link to="/pieta"><img src={pieta} alt="affiche du film"/></Link>
            <Link to="/blood"><img src={blood} alt="affiche du film"/></Link>
            <Link to="/tour"><img src={laTour} alt="affiche du film"/></Link>
            <Link to="/montagne"><img src={laMontagne} alt="affiche du film"/></Link>
        </div>
    </div>
  )
}

export default ListFilm